function TrieNode(key) {
    this.key = key;
    this.isCompleteWord = false;
    this.children = {};
    this.parent = null;
    this.value = null;
}
function Trie() {
    this.root = new TrieNode(null);
}

function InsertWordToTrie(trie, word, value) {
    let node = trie.root;
    for (let i = 0; i < word.length; i++) {
        const char = word[i];
        if (!node.children[char]) {
            node.children[char] = new TrieNode(char);
            node.children[char].parent = node;
        }
        node = node.children[char];
        if (i === word.length - 1) {
            node.isCompleteWord = true;
            node.value = value;
        }
    }
}

function findInTrie(trie, prefix) {
    function findAWord(node) {
        if (node.isCompleteWord) {
            return node.value;
        }
        for (let child in node.children) {
            let word = findAWord(node.children[child]);
            if(word){
                return word
            }
        }
    }
    let node = trie.root;
    let bestMatch = null;
    for (let i = 0; i < prefix.length; i++) {
        const char = prefix[i];
        if (node.children[char]) {
            node = node.children[char];
            if (node.isCompleteWord) {
                bestMatch = node.value;
            }
        }
    }
    if (!bestMatch) {
        return findAWord(node);
    }
    return bestMatch;
}

const getCountriesTrie = (countries) => {
    let trie = new Trie();
    countries.forEach((country) => {
        InsertWordToTrie(trie, country.dialCode.substring(1), country);
        if (country.areaCodes) {
            let dialCode = country.dialCode.substring(1);
            country.areaCodes.forEach((areaCode) => {
                InsertWordToTrie(trie, dialCode + areaCode, country);
            });
        }
    });
    return trie;
};

export {findInTrie,getCountriesTrie}